<template>
  <b-modal id="new-user-modal" ref="new-user-modal" size="lg" @hidden="resetForm"
           :title="modalTitle" centered :hide-footer="true" class="mt-0">
    <template>
      <div id="datos-usuario">
        <div>
          <h5>Datos Usuario</h5>
        </div>
        <b-form>
          <b-row>
            <b-col>
              <b-form-group class="font-size-1rem" label="Nick *">
                <b-form-input v-model="newUser.username"
                              v-validate="'required|max:255'"
                              name="Nick" :state="errors.has('Nick') ? false : null">
                </b-form-input>
                <span class="error">{{ errors.first('Nick') }}</span>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group class="font-size-1rem" label="Email *">
                <b-form-input v-model="newUser.email"
                              v-validate="'required|max:255|email'"
                              name="Email" :state="errors.has('Email') ? false : null">
                </b-form-input>
                <span class="error">{{ errors.first('Email') }}</span>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group class="font-size-1rem" label="Nombre *">
                <b-form-input v-model="newUser.first_name"
                              v-validate="'required|max:255'"
                              name="Nombre" :state="errors.has('Nombre') ? false : null">
                </b-form-input>
                <span class="error">{{ errors.first('Nombre') }}</span>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group class="font-size-1rem" label="Apellidos *">
                <b-form-input v-model="newUser.last_name"
                              v-validate="'required|max:255'"
                              name="Apellidos" :state="errors.has('Apellidos') ? false : null">
                </b-form-input>
                <span class="error">{{ errors.first('Apellidos') }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group class="font-size-1rem" label="Metadatos">
                <b-form-input v-model="newUser.metadatos" v-validate.immediate="'max:255'" name="Metadatos">
                </b-form-input>
                <span class="error">{{ errors.first('Metadatos') }}</span>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>
      <div id="permissions-selection">
        <div>
          <h5>Selección Permisos</h5>
        </div>
        <div class="d-flex flex-column">
          <div class="d-flex flex-row" id="permissions-selection-type">
            <div class="d-flex flex-row align-items-center" id="permissions-input-manual">
              <input type="radio" id="manual" value="manual" v-model="profileSelectionType">
              <label for="manual" class="mb-0">Manualmente</label>
            </div>
            <div class="d-flex flex-row align-items-center" id="permissions-input-user">
              <input type="radio" id="byUser" value="byUser" v-model="profileSelectionType">
              <label for="byUser" class="mb-0">Por usuario</label>
              <multiselect
                id="multiselect-user"
                v-model="userSelected"
                :options="usersList"
                :disabled="profileSelectionType === 'manual'"
                label="username"
                track-by="username"
                placeholder=""
                :custom-label="getCustomLabelUser"
                size="sm"
                class="multiselect-user"
                @select="updateUserSelected($event)">
              </multiselect>
              <b-spinner variant="primary" label="Downloading Permissions" v-if="downloadingUserPermissions">
              </b-spinner>
            </div>
          </div>

          <b-list-group class="scroll-permissions w-100">
            <b-list-group-item id="permissions-header" class="d-flex align-items-center position-sticky">
              <span class="flex-30">Grupos</span>
              <div class="d-flex flex-70 text-center ">
                <span v-for="(permission, i) in permissionsList" v-bind:key="i" class="text-capitalize flex-1">
                  {{ permission.permiso.toLowerCase() }}
                </span>
              </div>
            </b-list-group-item>

            <b-list-group-item v-for="(role, i) in rolesList" v-bind:key="i" class="d-flex row-padding">
              <span class="text-capitalize flex-30">{{ role.rol.toLowerCase() }}</span>
              <b-form-group class="mb-0 flex-70">
                <div class="d-flex flex-wrap">
                  <b-form-checkbox
                    v-for="permission in permissionsList"
                    :disabled="profileSelectionType === 'byUser'"
                    :key="permission.letra"
                    v-model="newUser.permisos[role.rol][permission.letra]"
                    class="custom-checkbox"
                    inline>
                  </b-form-checkbox>
                </div>
              </b-form-group>
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
      <br>
      <b-row>
        <b-col class="text-align-right">
          <div class="d-flex align-items-center">
            <b-form-checkbox v-model="newUser.enviar_notificacion" class="d-block mr-16">
              Enviar notificación
            </b-form-checkbox>
            <b-button @click="createUser" variant="primary"> Alta</b-button>
          </div>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<style scoped>

.text-align-right {
  text-align: right;
}

.font-size-1rem {
  font-size: 1rem;
}

.flex-30 {
  flex: 30;
}

.flex-70 {
  flex: 70;
}

.flex-1 {
  flex: 1;
}

.mr-16 {
  margin-right: 16px !important;
}

.row-padding {
  padding: .50rem 1.25rem;
}

#permissions-selection {
  padding: 12px 0;
}

#permissions-selection-type {
  margin: 8px 0;
}

#permissions-input-user {
  margin-left: 20px
}

#manual {
  margin-right: 4px;
  height: 20px;
}

#byUser {
  margin-right: 4px;
  height: 20px;
}

#permissions-header {
  background-color: #f7f7f7;
  top: 0;
  z-index: 10;
}

.multiselect-user {
  margin: 0 16px;
  width: 400px;
  z-index: 20;
}

.custom-checkbox {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  padding-left: 2.5rem;
  margin: 0;
}

@media screen and (max-height: 800px) {
  .scroll-permissions {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 39vh;
  }
}

@media screen and (min-height: 801px) {
  .scroll-permissions {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 46vh;
  }
}

</style>

<script>
import Loader from '@/components/Layout/Loader.vue';
import EventBus from '../../../../Modules/EventBus';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  name: 'NewUser',
  props: ['permisos'],
  components: {Loader},
  data () {
    return {
      modalTitle: 'Nuevo Usuario',
      newUser: {
        username: '',
        email: '',
        first_name: '',
        last_name: '',
        metadatos: '',
        permisos: {},
        enviar_notificacion: false
      },
      profileSelectionType: 'manual',
      userSelected: {},
      usersList: [],
      rolesList: [],
      permissionsList: [],
      downloadingUserPermissions: false
    };
  },
  mounted: function () {
    this.initData();
  },
  watch: {
    profileSelectionType: function (val, oldVal) {
      if (val === 'byUser' && this.userSelected && this.userSelected.id) {
        this.updateUserSelected(this.userSelected);
      }
    }
  },
  methods: {
    initData: function () {
      const self = this;
      Promise.all([
        this.$http.get('roles/', {params: {not_paginated: true}}),
        this.$http.get('permisos/', {params: {not_paginated: true}}),
        this.$http.get('usuarios-activos/')
      ]).then(response => {
        self.rolesList = response[0].data;
        self.permissionsList = response[1].data;
        self.usersList = response[2].data;

        // Creamos el objeto de roles-permisos inicial, con todos los valores seteados a "false"
        self.rolesList.forEach(role => {
          self.newUser.permisos[role.rol] = Object.assign({}, ...self.permissionsList.map((x) => ({[x.letra]: false})));
        });
      });
    },
    getCustomLabelUser: function (option) {
      return (option.id) ? `${option.username} - ${option.first_name} ${option.last_name}` : '';
    },
    updateUserSelected: function (userSelected) {
      this.downloadingUserPermissions = true;
      this.$http.get(`usuarios/${userSelected.id}/`).then(response => {
        this.newUser.permisos = response.data.permisos;
        this.downloadingUserPermissions = false;
      });
    },
    createUser: function () {
      this.$validator.validate().then(result => {
        if (!result) {
          EventBus.$emit('show-error-alert', 'El formulario contiene algunos errores, por favor revise los valores introducidos');
        } else {
          this.$http.post('usuarios/', this.newUser).then(result => {
            // Mostramos mensaje y actualizmos el listado de usuarios de la ventana gestión de usuarios.
            EventBus.$emit('show-success-alert', 'Usuario creado correctamente');
            this.$emit('update-users-list');

            // Cerramos el dialogo
            this.$bvModal.hide('new-user-modal');
          }, reason => {
            console.log(reason);
            EventBus.$emit('show-error-alert', 'Error al crear el usuario');
          });
        }
      });
    },
    resetForm: function () {
      this.newUser.username = '';
      this.newUser.email = '';
      this.newUser.first_name = '';
      this.newUser.last_name = '';
      this.newUser.metadatos = '';

      this.rolesList.forEach(role => {
        this.newUser.permisos[role.rol] = Object.assign({}, ...this.permissionsList.map((x) => ({[x.letra]: false})));
      });

      this.userSelected = {};
      this.profileSelectionType = 'manual';
      this.$validator.reset();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Layout/SystemManagement/users-management/new-user/NewUser.vue